import Icon from "@mui/material/Icon";
import Tooltip from "@material-ui/core/Tooltip";

const dispatcherQuickMenus = [
  {
    icon: (
      <Tooltip title="Map Dashboard">
        <Icon fontSize="medium">view_carousel</Icon>
      </Tooltip>
    ),
    name: "Default Dashboard",
    key: "nms.suraksha",
    url: "home/app/map",
    description: "Dashboard",
  },
  // {
  //   icon: (
  //     <Tooltip title="GeoFence Configuration">
  //       <Icon fontSize="medium">display_settings_icon</Icon>
  //     </Tooltip>
  //   ),
  //   key: "geoFence",
  //   name: "geoFence",
  //   url: "home/app/geofence",
  //   description: "geofencing Configuration",
  // },
  {
    icon: (
      <Tooltip title="Group Dashboard">
        <Icon fontSize="medium">group_icon</Icon>
      </Tooltip>
    ),
    name: "Group-Dashboard",
    key: "groupDashboard",
    url: "home/app/group",
    description: "Group Dashboard",
  },
  {
    icon: (
      <Tooltip title="CDR">
        <Icon fontSize="medium">menu_icon</Icon>
      </Tooltip>
    ),
    name: "PPDR-CDR",
    key: "ppdr.cdr",
    url: "home/app/CDR-list",
    description: "List",
  },
  {
    icon: (
      <Tooltip title="Active Conference">
        <Icon fontSize="medium">groups_icon</Icon>
      </Tooltip>
    ),
    name: "Active Conference",
    key: "ActiveConference",
    url: "home/app/Active Conference",
    description: "Active Conference",
  },
  {
    icon: (
      <Tooltip title="Calls In Waiting">
        <Icon fontSize="medium">call_icon</Icon>
      </Tooltip>
    ),
    name: "call",
    key: "groupCallInQueue",
    url: "home/app/call",
    description: "Call",
  },
  {
    icon: (
      <Tooltip title="Dashboard">
        <Icon fontSize="medium">dashboard</Icon>
      </Tooltip>
    ),
    name: "Dashboard",
    key: "dashboard.controller",
    url: "home/app/dashboard",
    description: "Dashboard",
  },
  {
    icon: (
      <Tooltip title="Task Manager">
        <Icon fontSize="medium">assignment_turned_in_icon</Icon>
      </Tooltip>
    ),
    key: "taskManager",
    name: "Task Manager",
    url: "home/app/taskManager",
    description: "Task Manager",
  },

  {
    icon: (
      <Tooltip title="V3 Testing">
        <Icon fontSize="medium">mic</Icon>
      </Tooltip>
    ),
    key: "v3Testing",
    name: "V3 Testing",
    url: "home/app/v3Testing",
    description: "V3 Testing",
  },
];

export { dispatcherQuickMenus };
